import { ApolloLink } from '@apollo/client';
import { TerminalToken } from 'libs/terminal/token';
/**
 * Adds the paired device's token to every terminal request.
 *
 * Deliberately not the session token of requestLink: the floor app has no
 * user session, and nothing about it should start working just because
 * somebody happens to be signed in to the back office in another tab.
 *
 * @const terminalLink
 * @since 1.0.0
 */
export const terminalLink = new ApolloLink((operation, forward) => {
    const token = TerminalToken.get();
    operation.setContext({
        headers: token ? { 'X-Terminal-Token': token } : {}
    });
    return forward(operation);
});
